import { ColDef } from "@ag-grid-community/core";
import { formatResearchUseStatements, formatStatementCategory } from "./approvedUsersUtils";
import ResearchUseStatementCell from "./components/ResearchUseStatementCell";

export const ApprovedUsersColumnDefinitions: ColDef[] = [
    {
        field: "firstName",
        headerName: "First name",
        sortable: true,
        filter: 'agTextColumnFilter',
        minWidth: 200,
        flex: 1.5,
    },
    {
        field: "lastName",
        headerName: "Last name",
        sortable: true,
        filter: 'agTextColumnFilter',
        minWidth: 200,
        flex: 1.5,
    },
    {
        field: "ducExpiresOn",
        headerName: "DUC Expiration Date",
        sortable: true,
        filter: 'agTextColumnFilter',
        minWidth: 220,
        flex: 1.5,
    },
    {
        field: "ducCategory",
        headerName: "DUC Category",
        sortable: true,
        filter: 'agTextColumnFilter',
        minWidth: 220,
        flex: 1.5,
        valueGetter: (params: any) => formatStatementCategory(params.data?.ducCategory ?? ''),
    },
    {
        field: "institution",
        headerName: "Institution",
        sortable: true,
        filter: 'agTextColumnFilter',
        minWidth: 220,
        flex: 2,
    },
    {
        field: "researchUseStatements",
        headerName: "Research Use Statement",
        sortable: true,
        filter: 'agTextColumnFilter',
        minWidth: 320,
        flex: 3,
        wrapText: true,
        autoHeight: true,
        valueGetter: (params: any) => formatResearchUseStatements(params.data?.researchUseStatements),
        cellRenderer: ResearchUseStatementCell,
    },
];
